import { memo } from 'react';

const ColorsTab = memo(({ colors, onColorSwap, t }) => (
  <div>
    <p style={{ fontFamily: 'var(--sans)', fontSize: '12px', color: t.muted, marginBottom: '14px' }}>
      Click any color to change it across your page
    </p>
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
      {colors.map(c => (
        <div key={c} style={{ position: 'relative', textAlign: 'center' }}>
          <label style={{ display: 'block', cursor: 'pointer' }}>
            <div style={{
              width: '48px', height: '48px', borderRadius: '12px', background: c,
              border: `2px solid ${t.border}`, transition: 'transform .15s, box-shadow .15s',
              boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.1)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.25)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)'; }}
            />
            <input
              type="color" defaultValue={c}
              onChange={e => onColorSwap(c, e.target.value)}
              style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }}
              title={c}
            />
          </label>
          <span style={{ display: 'block', fontFamily: 'var(--sans)', fontSize: '9px', color: t.muted, marginTop: '4px', opacity: 0.6 }}>{c}</span>
        </div>
      ))}
    </div>
    {colors.length === 0 && (
      <p style={{ fontSize: '12px', color: t.muted, fontStyle: 'italic', textAlign: 'center', padding: '20px 0', fontFamily: 'var(--sans)' }}>
        No colors detected yet. Try editing your site first.
      </p>
    )}
    <p style={{ fontFamily: 'var(--sans)', fontSize: '11px', color: t.muted, marginTop: '16px', opacity: 0.6 }}>
      Changes apply instantly across the active page.
    </p>
  </div>
));

ColorsTab.displayName = 'ColorsTab';
export default ColorsTab;
